export default __webpack_public_path__ + "static/media/like-icon.ad693b3e.svg";